import { css } from '@emotion/core';

export const customerStatFilterMobileCSS = css`
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    height: 100%;
`;

export const customerStatFilterHeaderMobileCSS = css`
    display: flex;
    justify-content: space-between;
    padding-bottom: 1rem;
`;

export const customerStatFilterHeaderTextMobileCSS = css`
    padding: 0.5rem;
    font-size: larger;
`;

export const customerStatFilterMobileFooterCSS = css`
    width: 100%;

    button {
        height: 2.5rem;
        min-width: 5rem;
    }
`;

export const customerStatFilterMobileCancelApplyContainerCSS = css`
    display: flex;
    gap: 1rem;
    float: right;
`;

export const customerStatFilterCloseOverlayButtonCSS = ({ colors }) => css`
    border-radius: 2.5rem;
    height: 2.5rem;
    width: 2.5rem;

    > svg {
        color: ${colors.neutral30};
        &:hover,
        &:active,
        &:focus {
            color: ${colors.neutral30};
        }
    }
`;
